import React from 'react';

/**
 * Collapsible per-domain breakdown of a governance maturity value (8 domains, Governance Maturity
 * Model.xlsx). A domain with `level: null` was not measured: it is shown as "Not measured", never as
 * a level or a zero. Renders nothing for an old snapshot that has no `domains`. Native <details> so
 * it is keyboard-accessible with no extra component dependency.
 */
const MaturityDomainBreakdown = ({ domains, testId = 'maturity-domains', defaultOpen = false }) => {
  if (!Array.isArray(domains) || domains.length === 0) return null;
  const measured = domains.filter((d) => d && typeof d.level === 'number').length;
  return (
    <details data-testid={testId} open={defaultOpen} style={{ fontSize: 13 }}>
      <summary style={{ cursor: 'pointer' }}>
        Domain breakdown ({measured} of {domains.length} measured)
      </summary>
      <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
        {domains.map((d, i) => (
          <li key={d.domainId || i} data-testid={`maturity-domain-${d.domainId || i}`} style={{ marginBottom: 6 }}>
            <strong>{d.domain || d.domainId}</strong>
            {': '}
            {typeof d.level === 'number' ? `Level ${d.level}${d.levelName ? ` · ${d.levelName}` : ''}` : 'Not measured'}
            {typeof d.evidence === 'string' && d.evidence.trim() ? <div style={{ color: 'var(--color-text-muted)' }}>{d.evidence}</div> : null}
          </li>
        ))}
      </ul>
    </details>
  );
};

export default MaturityDomainBreakdown;
